<button type="button"
        [class.has-icon]="icon || iconFont"
        [class.has-text]="content"
        [disabled]="isDisabled"
        (click)="buttonClicked($event)">
    @if (iconSlot === 'icon') {
        <slot name="icon">
            @if (icon) {
                <ws-ace-icon
                    [glyph]="icon"
                    slot="icon"
                    [size]="iconSize"
                    [attr.disabled]="isDisabled"
                    [state]="(isDisabled ? 'disabled' : state)">
                </ws-ace-icon>
            }
            @if (iconFontClass) {
                <span class="ace-icon fa" [ngClass]="iconFontClass"></span>
            }
        </slot>
    }
    @if (content) {
        <span class="button-txt text-nowrap">{{ content }}</span>
    }
    @if (iconSlot === 'icon-right') {
        <slot name="icon-right">
            @if (icon) {
                <ws-ace-icon
                    [glyph]="icon"
                    slot="icon"
                    [size]="iconSize"
                    [attr.disabled]="isDisabled"
                    [state]="(isDisabled ? 'disabled' : state)">
                </ws-ace-icon>
            }
            @if (iconFontClass) {
                <span class="ace-icon fa" [ngClass]="iconFontClass"></span>
            }
        </slot>
    }
</button>

